import {faBold} from '@fortawesome/free-solid-svg-icons/faBold';
import {faItalic} from '@fortawesome/free-solid-svg-icons/faItalic';
import {faUnderline} from '@fortawesome/free-solid-svg-icons/faUnderline';
import {faStrikethrough} from '@fortawesome/free-solid-svg-icons/faStrikethrough';
import {faAlignLeft} from '@fortawesome/free-solid-svg-icons/faAlignLeft';
import {faAlignCenter} from '@fortawesome/free-solid-svg-icons/faAlignCenter';
import {faAlignRight} from '@fortawesome/free-solid-svg-icons/faAlignRight';
import {faAlignJustify} from '@fortawesome/free-solid-svg-icons/faAlignJustify';
import {faCut} from '@fortawesome/free-solid-svg-icons/faCut';
import {faCopy} from '@fortawesome/free-solid-svg-icons/faCopy';
import {faIndent} from '@fortawesome/free-solid-svg-icons/faIndent';
import {faSubscript} from '@fortawesome/free-solid-svg-icons/faSubscript';
import {faOutdent} from '@fortawesome/free-solid-svg-icons/faOutdent';
import {faSuperscript} from '@fortawesome/free-solid-svg-icons/faSuperscript';
import {faUndo} from '@fortawesome/free-solid-svg-icons/faUndo';
import {faRedo} from '@fortawesome/free-solid-svg-icons/faRedo';
import {faListUl} from '@fortawesome/free-solid-svg-icons/faListUl';
import {faListOl} from '@fortawesome/free-solid-svg-icons/faListOl';
import {faLink} from '@fortawesome/free-solid-svg-icons/faLink';
import {faUnlink} from '@fortawesome/free-solid-svg-icons/faUnlink';
import {faCode} from '@fortawesome/free-solid-svg-icons/faCode';


export const ICONS = {
  faBold,
  faItalic,
  faUnderline,
  faStrikethrough,
  faAlignLeft,
  faAlignCenter,
  faAlignRight,
  faAlignJustify,
  faCut,
  faCopy,
  faIndent,
  faOutdent,
  faSubscript,
  faSuperscript,
  faUndo,
  faRedo,
  faListUl,
  faListOl,
  faLink,
  faUnlink,
  faCode
};
